import React from "react";

/**
 * SliderProgressBar component
 * @param {Object} props - The properties passed to the component
 * @param {number} props.total - The total number of slides
 * @param {number} props.current - The current slide number
 * @param {string} props.className - The additional class names
 */
const SliderProgressBar = ({ total, current, className = "" }) => (
    <div className={`flex items-center gap-2 ${className}`}>
        {/* Background of the progress bar */}
        <div className="rounded basis-[calc(100%-50px)] bg-blue bg-opacity-20 h-[7px]">
            {/* Foreground of the progress bar */}
            <div
                className="bg-green rounded h-full transition-[width] duration-400 ease-linear"
                style={{ width: `${(current / total) * 100}%` }}
            />
        </div>
        {/* Display of current slide number and total slide number */}
        <p className="flex-grow text-blue text-xxs tracking-[-0.36px] font-medium text-right whitespace-nowrap">
            {current} of {total}
        </p>
    </div>
);

export default SliderProgressBar;
